import React, { useState } from 'react';
import { PanelShell } from '../ui/PanelShell';
import { SectionTitle } from '../ui/SectionTitle';
import { FieldRow } from '../ui/FieldRow';
import { NumberField } from '../ui/NumberField';
import { PillButton } from '../ui/PillButton';
type HollowPanelProps = {
  onClose: () => void;
};
export function HollowPanel({
  onClose
}: HollowPanelProps) {
  const [hollowed, setHollowed] = useState(false);
  return <PanelShell title="Hollow" onClose={onClose} footer={<>
          <PillButton disabled={!hollowed} onClick={() => setHollowed(false)} data-id="element-352" data-mp="3mbovwi17bomo">
            Reset All
          </PillButton>
          <PillButton variant="primary" onClick={() => setHollowed(true)} data-id="element-353" data-mp="37f7ou301ow5x">
            {hollowed ? 'Hollowed' : 'Hollow All'}
          </PillButton>
        </>} data-id="element-351" data-mp="3harkcoap5su5">
      
      <SectionTitle data-id="element-354" data-mp="15n3173pkwl10">Geometry</SectionTitle>
      <FieldRow label="Wall Thickness" info className="min-h-[31px]" data-id="element-355" data-mp="15k723c1zvqaz">
        <NumberField ariaLabel="Wall thickness" value={1.5} unit="mm" data-id="element-356" data-mp="1akl0e2dsnlvt" />
      </FieldRow>
      <SectionTitle info data-id="element-357" data-mp="30kl2gumng1y5">Inner Surface</SectionTitle>
      <FieldRow label="Feature Size" info className="min-h-[31px]" data-id="element-358" data-mp="2vmsxp00wolcj">
        <NumberField ariaLabel="Feature size" value={1.0} unit="mm" data-id="element-359" data-mp="2vmj8henoqi7w" />
      </FieldRow>
      <FieldRow label="Accuracy" info className="min-h-[31px]" data-id="element-360" data-mp="3ab5ycaaxusdd">
        <NumberField ariaLabel="Accuracy" value={50} decimals={0} step={5} max={100} unit="%" data-id="element-361" data-mp="35c2u2s2s8q6g" />
      </FieldRow>
    </PanelShell>;
}